import { useSnackbar } from 'notistack';
import Context from './Context';

const Provider = ({ children }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const defaultProps = {
        autoHideDuration: 3000,
        preventDuplicate: true,
        anchorOrigin: { vertical: 'top', horizontal: 'center' }
    };
    const toast = (msg = '', ...props) => {
        enqueueSnackbar(msg, {
            variant: 'default',
            ...defaultProps,
            ...props
        });
    };
    const success = (msg = '', ...props) => {
        enqueueSnackbar(msg, {
            variant: 'success',
            ...defaultProps,
            ...props
        });
    };
    const info = (msg = '', ...props) => {
        enqueueSnackbar(msg, {
            variant: 'info',
            ...defaultProps,
            ...props
        });
    };
    const warning = (msg = '', ...props) => {
        enqueueSnackbar(msg, {
            variant: 'warning',
            ...defaultProps,
            ...props
        });
    };
    const danger = (msg = '', ...props) => {
        enqueueSnackbar(msg, {
            variant: 'error',
            ...defaultProps,
            ...props
        });
    };
    const close = (msg = '', ...props) => {
        closeSnackbar();
    };

    const props = {
        toast,
        success,
        info,
        warning,
        danger,
        close
    };

    return <Context.Provider value={props}>{children}</Context.Provider>;
};

export default Provider;
